import { render, staticRenderFns } from "./LoRenameCreate.vue?vue&type=template&id=25743d2a"
import script from "./LoRenameCreate.vue?vue&type=script&lang=js"
export * from "./LoRenameCreate.vue?vue&type=script&lang=js"
import style0 from "./LoRenameCreate.vue?vue&type=style&index=0&id=25743d2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports